import { render, staticRenderFns } from "./aweme-distributor.vue?vue&type=template&id=0fdaa27d&scoped=true"
import script from "./aweme-distributor.vue?vue&type=script&setup=true&lang=js"
export * from "./aweme-distributor.vue?vue&type=script&setup=true&lang=js"
import style0 from "./aweme-distributor.vue?vue&type=style&index=0&id=0fdaa27d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdaa27d",
  null
  
)

export default component.exports